export interface CrazyGamesAdCallbacks {
  readonly adStarted?: () => void;
  readonly adFinished?: () => void;
  readonly adError?: (error: unknown) => void;
}

export interface CrazyGamesSDK {
  readonly environment?: "local" | "crazygames" | "disabled" | string;
  init(): Promise<void>;
  readonly ad: {
    requestAd(type: "rewarded" | "midgame", callbacks: CrazyGamesAdCallbacks): void;
    hasAdblock?(): Promise<boolean>;
  };
  readonly game: {
    readonly settings?: {
      readonly muteAudio?: boolean;
      readonly disableChat?: boolean;
    };
    gameplayStart(): void;
    gameplayStop(): void;
    loadingStart?(): void;
    loadingStop?(): void;
  };
  readonly banner: {
    requestBanner(params: { id: string; width: number; height: number }): Promise<void> | void;
    clearBanner?(id: string): Promise<void> | void;
    requestResponsiveBanner?(id: string): Promise<void> | void;
  };
}

declare global {
  interface Window {
    CrazyGames?: { SDK?: CrazyGamesSDK };
  }
}

let initPromise: Promise<CrazyGamesSDK | null> | null = null;

export function currentCrazyGamesSdk(): CrazyGamesSDK | null {
  return typeof window !== "undefined" ? window.CrazyGames?.SDK ?? null : null;
}

export function initCrazyGamesSdk(enabled: boolean): Promise<CrazyGamesSDK | null> {
  if (!enabled || typeof window === "undefined") return Promise.resolve(null);
  if (!initPromise) {
    initPromise = (async () => {
      const sdk = currentCrazyGamesSdk();
      if (!sdk) return null;
      try {
        await sdk.init();
        return sdk;
      } catch (error) {
        console.warn("[CrazyGames] SDK init failed", error);
        return null;
      }
    })();
  }
  return initPromise;
}

export function isCrazyGamesWebBuild(): boolean {
  return (import.meta.env["VITE_WEB_AD_PROVIDER"] as string | undefined) === "crazygames";
}
